import { ImpactModule } from 'types'
import { ASSESSMENTS_AND_RESEARCH_PAGES } from './pages'
import { ASSESSMENTS_AND_RESEARCH_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const ASSESSMENTS_AND_RESEARCH_MODULE: ImpactModule = {
  NAME: 'research',
  NAME_PTBR: 'Avaliações e pesquisas',
  // UPPER_NAME: 'ASSESSMENT_AND_RESEARCH',
  UPPER_NAME: 'RESEARCH',
  // API_NAME: 'ASSESSMENT_AND_RESEARCH',
  API_NAME: 'RESEARCH',
  PAGES: ASSESSMENTS_AND_RESEARCH_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: ASSESSMENTS_AND_RESEARCH_PAGES_ORDER_FOR_PERMISSIONS,
}
